<!-- class students list -->
<template>
  <div>
    <gg-flex-menus :menus="menuDatas" @select="menuSelect" :default-active="activeIndex">
    </gg-flex-menus>
    <div class="sub-mn">
      <span class="tit">Library</span>
      <gg-flex-menus :menus="menuDatas2" @select="menuSelect" :default-active="activeIndex">
      </gg-flex-menus>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// const _menuDatas= [
//         {
//           name: "Students",
//           key: "momentClass",
//           children: [],
//         },
//         {
//           name: "Photos",
//           key: "momentClassPhotos",
//           children: [
//             {
//               name: "Uploaded",
//               key: "momentClassUploaded",
//               children: [],
//             },
//             {
//               name: "Pending",
//               key: "momentClassPending",
//               extra:'123',
//               children: [],
//             },
//             {
//               name: "Shared",
//               key: "momentClassShared",
//               children: [],
//             }
//           ],
//         },
//         // {
//         //   name: "Library",
//         //   active:true,
//         //   children: [
//         //     {
//         //       name: "Album",
//         //       key: "momentClassAlbum",
//         //       children: [],
//         //     },
//         //     {
//         //       name: "Trash",
//         //       key: "momentClassTrash",
//         //       children: [],
//         //     },
//         //   ],
//         // },
//       ];
export default {
  props: {
    activeIndex: {
      default: '',
      type: String
    }
  },
  data() {
    return {
      menuDatas: [],
      menuDatas2: []
    }
  },
  methods: {
    generateMenuDatas() {
      return [
        {
          name: 'Students',
          key: 'momentClass',
          children: []
        },
        {
          name: 'Photos',
          key: 'momentClassPhotos',
          children: [
            {
              name: 'Uploaded',
              key: 'momentClassUploaded',
              children: []
            },
            {
              name: 'Pending',
              key: 'momentClassPending',
              extra: this.pendingCount,
              children: []
            },
            {
              name: 'Shared',
              key: 'momentClassShared',
              children: []
            }
          ]
        },
        {
          name: 'Videos',
          key: 'momentClassVideos',
          children: [
            {
              name: 'Uploaded',
              key: 'momentClassVideoUploaded',
              children: []
            },
            {
              name: 'Pending',
              key: 'momentClassVideoPending',
              extra: this.pendingVideoCount,
              children: []
            },
            {
              name: 'Shared',
              key: 'momentClassVideoShared',
              children: []
            }
          ]
        }
        // {
        //   name: "Library",
        //   active:true,
        //   children: [
        //     {
        //       name: "Album",
        //       key: "momentClassAlbum",
        //       children: [],
        //     },
        //     {
        //       name: "Trash",
        //       key: "momentClassTrash",
        //       children: [],
        //     },
        //   ],
        // },
      ]
    },
    generateMenuDatas2() {
      return [
        {
          name: 'Album',
          key: 'momentClassAlbum',
          children: []
        },
        {
          name: 'Trash',
          key: 'momentClassTrash',
          children: [
            {
              name: 'Photos',
              key: 'momentClassTrashPhotos',
              children: []
            },
            {
              name: 'Videos',
              key: 'momentClassTrashVideos',
              children: []
            }
          ]
        }
      ]
    },
    menuSelect(key, item) {
      const routeMap = {
        momentClassVideos: {
          name: 'momentClassPhotos',
          mediaType: '1'
        },
        momentClassVideoUploaded: {
          name: 'momentClassUploaded',
          mediaType: '1'
        },
        momentClassVideoPending: {
          name: 'momentClassPending',
          mediaType: '1'
        },
        momentClassVideoShared: {
          name: 'momentClassShared',
          mediaType: '1'
        },
        momentClassTrashPhotos: {
          name: 'momentClassTrash'
        },
        momentClassTrashVideos: {
          name: 'momentClassTrash',
          mediaType: '1'
        }
      }
      const routeData = routeMap[key] || { name: key }
      const query = this.$route.query.time ? { time: this.$route.query.time + '' } : {}
      if (routeData.mediaType) {
        query.mediaType = routeData.mediaType
      }
      this.$router.push({
        name: routeData.name,
        params: { id: this.$route.params.id },
        query
      })
    },
    init() {
      const _menuDatas = this.generateMenuDatas()
      const _menuDatas2 = this.generateMenuDatas2()
      this.menuDatas = [..._menuDatas]
      this.menuDatas2 = [..._menuDatas2]
      for (var i = 0; i < _menuDatas.length; i++) {
        const _cIdx = _menuDatas[i].children.findIndex((o) => o.key === this.activeIndex)
        if (_cIdx >= 0) {
          this.menuDatas[i].active = true
          break
        }
      }
      for (var i = 0; i < _menuDatas2.length; i++) {
        const _cIdx = _menuDatas2[i].children.findIndex((o) => o.key === this.activeIndex)
        if (_cIdx >= 0) {
          this.menuDatas2[i].active = true
          break
        }
      }
    }
  },
  computed: {
    ...mapState({
      pendingCount: (state) => state.moments.pendingCount,
      pendingVideoCount: (state) => state.moments.pendingVideoCount
    })
  },
  watch: {
    pendingCount() {
      // console.log(3333,this.pendingCount)
      this.init()
    },
    pendingVideoCount() {
      this.init()
    }
  },
  created() {
    this.init()
  }
}
</script>
<style lang="less" scoped>
//@import url(); 引入公共css类
.sub-mn {
  .tit {
    padding-left: 32px;
    font-size: 14px;
    color: #5f6368;
    height: 40px;
    line-height: 40px;
    font-family: OpenSans-Bold;
    cursor: pointer;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    padding-right: 24px;
  }
  /deep/ .menus > .menu_box > .menu_item {
    padding-left: 68px !important;
  }
  /deep/.menu_box .menu_box .menu_item {
    padding-left: 102px !important;
  }
}
</style>
